module.exports = __webpack_public_path__ + "img/2.2bd0dafe.png";